import { render } from "./PreloaderComponent.vue?vue&type=template&id=8de12554&scoped=true"
const script = {}

import "./PreloaderComponent.vue?vue&type=style&index=0&id=8de12554&lang=scss&scoped=true"

import exportComponent from "/Users/stepanmaksimov/Documents/Claude/Projects/A.sk/answerio-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8de12554"]])

export default __exports__